import { Router, UrlTree } from '@angular/router';
import { UserRole } from '../models/user-status.model';

/**
 * Dónde vive cada rol. Los guards de área usaban esta tabla escrita a mano,
 * repetida como la misma rama triple `manager` / `ventas` / socio en once
 * archivos; centralizarla significa que un rol nuevo se declara una vez y el
 * compilador obliga a completar la tabla (`Record<UserRole, …>`).
 */
export const ROLE_AREA_ROUTE: Record<UserRole, string> = {
  socio: '/home',
  manager: '/manager',
  ventas: '/sales',
  colaborador: '/collaborator',
};

/**
 * Redirección para un rol que no pertenece al área que se está protegiendo.
 *
 * - `allow`: roles que el guard deja seguir. Devuelve `null` para ellos, y el
 *   guard continúa con sus propias reglas (estado de registro, por ejemplo).
 * - `overrides`: destino específico para un rol cuando no es la portada de su
 *   área (un manager que cae en `/bookings` va a `/manager/bookings`).
 */
export function foreignRoleRedirect(
  router: Router,
  role: UserRole,
  allow: readonly UserRole[],
  overrides: Partial<Record<UserRole, string>> = {},
): UrlTree | null {
  if (allow.includes(role)) return null;
  return router.createUrlTree([overrides[role] ?? ROLE_AREA_ROUTE[role]]);
}
